import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=049e9aff&"
import script from "./AvatarUploader.vue?vue&type=script&lang=js&"
export * from "./AvatarUploader.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUploader.vue?vue&type=style&index=0&id=049e9aff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports